module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-engangsydelser text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom capitalize"
  }, [_vm._v("Engangsydelser")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
    staticClass: "sd-engangsydelser__header"
  }, [_c('div', {
    staticClass: "sd-engangsydelser__header__left"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.viewTab
    },
    on: {
      "select": _vm.onSelectViewTab
    }
  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedPersonNames,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.togglePersonName,
      "clear": function($event) {
        _vm.selectedPersonNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.userTags,
      "selectedTags": _vm.selectedUserTags,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleUserTag,
      "clear": function($event) {
        _vm.selectedUserTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Ansættelser',
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg stilling'
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Organisationer',
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg organisation'
    },
    on: {
      "select": _vm.toggleOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sd-engangsydelser__count"
  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "maximumDateRange": 730
    },
    on: {
      "startChanged": _vm.startDateChanged,
      "endChanged": _vm.endDateChanged
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Lønart',
      "tags": _vm.uniqueLoenart,
      "selectedTags": _vm.selectedLoenart,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg lønart'
    },
    on: {
      "select": _vm.toggleLoenart,
      "clear": function($event) {
        _vm.selectedLoenart = []
      }
    }
  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
    staticClass: "sd-engangsydelser__header__right"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--small",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.readEngangsydelser
    }
  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
    staticClass: "sd-engangsydelser__toolbar"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window'\n            }"
    }],
    staticClass: "sd-engangsydelser__toolbar__wrap",
    attrs: {
      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
    },
    attrs: {
      "disabled": _vm.selectedEmploymentIds.length === 0
    },
    on: {
      "click": _vm.openBulkCreate
    }
  }, [_vm._v("\n          Opret engangsydelser\n        ")])]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.cancelBatchMode
    }
  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
    staticClass: "sd-engangsydelser__count"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
    staticClass: "sd-engangsydelser__info"
  }, [_vm._v("\n      Engangsydelser i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-engangsydelser__body"
  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-check do-table__toggle-all",
    on: {
      "click": _vm.toggleAllSelected
    }
  }, [_c('div', {
    staticClass: "do-checkbox",
    class: {
      'do-checkbox--selected': _vm.isAllFilteredSelected
    }
  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
    staticClass: "th-row-actions"
  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 5
    }
  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
    return _c('tbody', {
      key: group.userId,
      staticClass: "user-group"
    }, _vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "employment-row",
        class: {
          'is-selected': _vm.isRowSelected(row)
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(row)
          }
        }
      }, [_c('td', {
        staticClass: "td-check",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onCheckboxClick(row)
          }
        }
      }, [_c('div', {
        staticClass: "do-checkbox",
        class: {
          'do-checkbox--selected': _vm.isRowSelected(row)
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
        staticClass: "td-row-actions"
      }, [(!_vm.isBatchMode) ? _c('button', {
        staticClass: "do-bttn do-bttn--small row-action-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.openSingleCreate(row)
          }
        }
      }, [_vm._v("Opret engangsydelse")]) : _vm._e()])])
    }), 0)
  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter td-created",
    class: {
      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vCreatedAt')
      }
    }
  }, [_vm._v("\n              OPRETTET "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'name'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n              NAVN "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'employment_number'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('employment_number')
      }
    }
  }, [_vm._v("\n              ANSÆTTELSE "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'loenart'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('loenart')
      }
    }
  }, [_vm._v("\n              LØNART "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-units",
    class: {
      'th-sorter--active': _vm.sortBy === 'antal'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('antal')
      }
    }
  }, [_vm._v("\n              ANTAL "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-units",
    class: {
      'th-sorter--active': _vm.sortBy === 'beloeb'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('beloeb')
      }
    }
  }, [_vm._v("\n              BELØB "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', [_vm._v("BESKRIVELSE")]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'dato'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('dato')
      }
    }
  }, [_vm._v("\n              DATO "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "td-created-by"
  }, [_vm._v("OPRETTET AF")]), _vm._v(" "), _c('th', {
    staticClass: "td-status"
  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 11
    }
  }, [_vm._v("\n              " + _vm._s(_vm.emptyTableText) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedRows), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "engangsydelse-row"
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vLoenart))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.enheder)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.sats)))]), _vm._v(" "), _c('td', {
      staticClass: "td-description"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(item.vDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-created-by"
    }, [_vm._v(_vm._s(item.vCreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [_c('span', {
      staticClass: "status-pill",
      class: 'status-pill--' + item.state
    }, [_vm._v(_vm._s(_vm.stateLabel(item.state)))])]), _vm._v(" "), _c('td', {
      staticClass: "td-actions"
    }, [(_vm.viewTab === 'outbox' && item.can_delete) ? _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "disabled": _vm.deletingIds.includes(item.id)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteRow(item)
        }
      }
    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
  })], 2)])]], 2)], _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('SdCreateEngangsydelse', {
    attrs: {
      "schoolId": _vm.schoolId,
      "employmentIds": _vm.createEmploymentIds,
      "subtitle": _vm.createSubtitle
    },
    on: {
      "created": _vm.onCreated,
      "close": _vm.closeCreate
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-engangsydelser-no-config"
  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5f33b8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/SdEngangsydelser.vue
// module id = 2078
// module chunks = 1